import React from 'react';
import { Link as ScrollLink } from 'react-scroll';
import './Footer.css'
const Footer = () => {
    return (
        <div className="Footer">
            <div className="box-container">
                <div className="box">
                    <span>Quick Links</span>
                    <a href="https://www.google.com/maps/place/BNM+Institute+of+Technology/@12.9219513,77.564949,17z/data=!3m1!4b1!4m6!3m5!1s0x3bae1581f297e32d:0xe9a257cf4383019e!8m2!3d12.9219513!4d77.5671377!16s%2Fm%2F0cr39lq"
                        target="_blank" rel="noreferrer"> <i className="fas fa-arrow-right"></i> Route Map </a>
                </div>

                <div className="box">
                    <span>Contact Info</span>
                    <a href="#contact"> <i className="fas fa-phone"></i> +91-80-26711781 </a>
                    <a href="#contact"> <i className="fas fa-phone"></i> +91-80-26711782 </a>
                  <a href="mailto:iitcee2027.bnmit@gmail.com" className="ex">
  <i className="fas fa-envelope"></i> iitcee2027.bnmit@gmail.com
</a>
                    <a href="mailto:bnmitprincipal@gmail.com" className="ex"> <i className="fas fa-envelope"></i> bnmitprincipal@gmail.com </a>
                </div>

                <div className="box">
                    <span>Follow Us</span>
                    <a href="https://www.facebook.com/bnmitsocial"> <i className="fab fa-facebook-f"></i> facebook </a>
                    <a href="https://twitter.com/BNMTech"> <i className="fab fa-twitter"></i> twitter </a>
                    <a href="https://www.instagram.com/bnmitsocial/"> <i className="fab fa-instagram"></i> instagram </a>
                    <a href="https://www.linkedin.com/school/bnm-institute-of-technology/"><i className="fab fa-linkedin"></i>
                        linkedin </a>
                </div>

                <div className="box">
                    <span>Website developed by</span>
                    <a href="https://www.linkedin.com/in/chandana-prajwal" target="_blank" rel="noreferrer"> <i className="fab fa-linkedin"></i>
                         <span style={{ color: 'blue', fontSize: '1.2em', fontWeight: 'bold' }}>
      Chandana M
    </span>
    <p>
      Department Of CSE
      </p>
    </a>
                   {/* <a href="https://www.linkedin.com/in/arjun-nadlumane" target="_blank" rel="noreferrer"> <i className="fab fa-linkedin"></i>
                        Arjun Nadlumane</a>
                    <a href="https://www.linkedin.com/in/jayatheerth-pz" target="_blank" rel="noreferrer"> <i className="fab fa-linkedin"></i>
                        Jayatheerth P Z </a>
                    <a href="https://www.linkedin.com/in/harshith-sd" target="_blank" rel="noreferrer"> <i className="fab fa-linkedin"></i> D S
                        Harshith</a>
                    <a href="https://www.linkedin.com/in/shreyas-k-s-485622230" target="_blank" rel="noreferrer"><i
                        className="fab fa-linkedin"></i>
                        Shreyas K S</a>*/}
                </div>
            </div>

            <div className="credit">copyrights <span> &copy;<b>bnmit-ieee</b></span> | all rights reserved </div>

        </div>
    )
}

export default Footer